var map = {
	"./ada.png": 19615,
	"./bib.png": 96607,
	"./btc.png": 98387,
	"./doge.png": 50578,
	"./eth.png": 83473,
	"./link.png": 70703,
	"./usdt.png": 88435
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 29343;